import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  MenuItem,
  Stack,
  Card,
  CardContent,
  Divider,
  Alert,
  Chip,
  Box
} from '@mui/material';
import {
  Save
} from '@mui/icons-material';
import {
  useNavigate,
  useParams,
  useLocation
} from 'react-router-dom';

import praticaApi from '../../api/praticaApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';

const statiPratica = [
  'APERTA',
  'IN_ATTESA_DOCUMENTI',
  'COMPLETATA',
  'CHIUSA'
];

const prioritaList = [
  'BASSA',
  'MEDIA',
  'ALTA',
  'URGENTE'
];

const tipoPraticaList = [
  'DICHIARAZIONE_REDDITI',
  'IMU',
  'IVA',
  'F24',
  'SUCCESSIONE',
  'CONTRATTO',
  'BONUS_EDILIZIO',
  'CONTENZIOSO',
  'ADEMPIMENTO',
  'ALTRO'
];

export default function CreatePraticaPage() {

  const { fascicoloId } = useParams();

  const location = useLocation();
  const navigate = useNavigate();

  const annoFiscaleId = location.state?.annoFiscaleId;
  const anno = location.state?.anno;

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [pratica, setPratica] = useState({
    nome: '',
    descrizione: '',
    tipo: 'ADEMPIMENTO',
    stato: 'APERTA',
    priorita: 'MEDIA',
    noteInterne: '',
    annoFiscaleId: annoFiscaleId,
    fascicoloId: fascicoloId
  });

  const handleChange = (field, value) => {
    setPratica(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {

    try {

      setLoading(true);

      await praticaApi.create({
        ...pratica
      });

      setSuccess(true);

      setTimeout(() => {
        navigate(-1);
      }, 1000);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  const getStatoColor = (stato) => {

    switch (stato) {

      case 'APERTA':
        return 'info';

      case 'IN_ATTESA_DOCUMENTI':
        return 'warning';

      case 'COMPLETATA':
        return 'success';

      case 'CHIUSA':
        return 'error';

      default:
        return 'default';
    }
  };

  return (

    <Container
      maxWidth="lg"
      sx={{ py: 3 }}
    >

      <BackButtonDesktop />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 3 }}
      >

        <Typography
          variant="h4"
          fontWeight={700}
        >
          Crea Pratica
        </Typography>

        <Chip
          label={pratica.stato}
          color={getStatoColor(pratica.stato)}
        />

      </Stack>

      {success && (

        <Alert
          severity="success"
          sx={{ mb: 3 }}
        >
          Pratica creata correttamente
        </Alert>

      )}

      <Card
        sx={{
          borderRadius: 3
        }}
      >

        <CardContent>

          <Typography
            variant="h6"
            sx={{ mb: 3 }}
          >
            Informazioni pratica
          </Typography>

          <Stack spacing={3}>

            <Typography
              variant="h6"
              sx={{ mb: 1 }}
            >
              Anno fiscale: {anno}
            </Typography>

            <TextField
              fullWidth
              label="Nome pratica"
              value={pratica.nome}
              onChange={(e) =>
                handleChange('nome', e.target.value)
              }
            />

            <TextField
              fullWidth
              multiline
              rows={4}
              label="Descrizione"
              value={pratica.descrizione}
              onChange={(e) =>
                handleChange('descrizione', e.target.value)
              }
            />
            <Divider />

            <Stack
              direction={{
                xs: 'column',
                md: 'row'
              }}
              spacing={2}
            >

              <TextField
                fullWidth
                select
                label="Tipo pratica"
                value={pratica.tipo || ''}
                onChange={(e) =>
                  handleChange('tipo', e.target.value)
                }
              >

                {tipoPraticaList.map((tipo) => (

                  <MenuItem
                    key={tipo}
                    value={tipo}
                  >
                    {tipo}
                  </MenuItem>

                ))}

              </TextField>

            </Stack>
            <Divider />

            <Stack
              direction={{
                xs: 'column',
                md: 'row'
              }}
              spacing={2}
            >

              <TextField
                fullWidth
                select
                label="Stato"
                value={pratica.stato}
                onChange={(e) =>
                  handleChange('stato', e.target.value)
                }
              >

                {statiPratica.map((s) => (

                  <MenuItem
                    key={s}
                    value={s}
                  >
                    {s}
                  </MenuItem>

                ))}

              </TextField>

              <TextField
                fullWidth
                select
                label="Priorità"
                value={pratica.priorita}
                onChange={(e) =>
                  handleChange('priorita', e.target.value)
                }
              >

                {prioritaList.map((p) => (

                  <MenuItem
                    key={p}
                    value={p}
                  >
                    {p}
                  </MenuItem>

                ))}

              </TextField>

            </Stack>

            <Divider />

            <TextField
              fullWidth
              multiline
              rows={5}
              label="Note interne"
              value={pratica.noteInterne}
              onChange={(e) =>
                handleChange('noteInterne', e.target.value)
              }
            />

            <Box>

              <Button
                variant="contained"
                startIcon={<Save />}
                onClick={handleSave}
                disabled={loading}
              >
                Salva
              </Button>

            </Box>

          </Stack>

        </CardContent>

      </Card>

    </Container>
  );
}
